interface RunningCountState {
    count: Map<number, {
        PersonIdCount: number,
        HouseholdIdCount: number,
        PersonKey: string,
        HouseholdKey: string
    }>;
    isQuickCountLoading: boolean;
}

type RunningCountAction =
    | {
        type: "SET_RUNNING_COUNT";
        count: {
            PersonIdCount: number,
            HouseholdIdCount: number,
            PersonKey: string,
            HouseholdKey: string
        };
        flowItemId: number
    }
    | { type: "SET_QUICK_COUNT_LOADING"; isQuickCountLoading: boolean }
    | { type: "REMOVE_RUNNING_COUNT"; flowItemId: number }
    | { type: "CLEAR_RUNNING_COUNTS" };

function runningCount(
    state: RunningCountState = {
        count: new Map<number, {
            PersonIdCount: number,
            HouseholdIdCount: number,
            PersonKey: string,
            HouseholdKey: string
        }>(),
        isQuickCountLoading: false
    },
    action: RunningCountAction
): RunningCountState {
    switch (action.type) {
        case "SET_RUNNING_COUNT":
            return {
                ...state,
                count: new Map(state.count).set(action.flowItemId, {
                    PersonIdCount: action.count.PersonIdCount,
                    HouseholdIdCount: action.count.HouseholdIdCount,
                    PersonKey: action.count.PersonKey,
                    HouseholdKey: action.count.HouseholdKey
                }),
                isQuickCountLoading: false,
            };

        case "SET_QUICK_COUNT_LOADING":
            return {
                ...state,
                isQuickCountLoading: action.isQuickCountLoading,
            };

        case "REMOVE_RUNNING_COUNT":
            {
                const newCount = new Map(state.count);
                newCount.delete(action.flowItemId);
                return {
                    ...state,
                    count: newCount,
                    isQuickCountLoading: false,
                };
            }

        case "CLEAR_RUNNING_COUNTS":
            return {
                ...state,
                count: new Map<number, {
                    PersonIdCount: number,
                    HouseholdIdCount: number,
                    PersonKey: string,
                    HouseholdKey: string
                }>(),
                isQuickCountLoading: false,
            };

        default:
            return state;
    }
}

export default runningCount;